import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import { StarIcon } from '@heroicons/react/24/solid';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Notify from '../../utils/useNotify';
import { useRefresh } from '../../utils/RefreshProvider';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

export default function WriteReview({ product_id }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [hover, setHover] = useState(0);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const localhost = process.env.REACT_APP_LOCALHOST;
  const userId = localStorage.getItem("userID");
  const token = localStorage.getItem("token");
  const { triggerRefresh } = useRefresh();
  const [btnLoading, setBtnLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (rating === 0) {
      Notify('warning', t("warning-rating-required"));
      return;
    }
    setBtnLoading(true);

    try {
      const reviewData = { rating, comment, user_id: parseInt(userId), product_id: product_id };
      await axios.post(`${localhost}review`, reviewData, { headers: { 'Authorization': `Bearer ${token}` } });
      triggerRefresh();
      setIsOpen(false);
      setRating(0);
      setComment("");
      Notify('success', t("s-add-rev"));
    } catch {
      Notify('error', t("e-add-rev"));
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <button disabled={!token ? true : false} onClick={() => setIsOpen(true)} className="disabled:bg-black/40 w-full py-2 px-4 rounded-md text-white bg-black hover:bg-black/80">
        {t("write-review")}
      </button>

      <Transition show={isOpen} as={Fragment}>
        <Dialog onClose={() => setIsOpen(false)} className="relative z-50">
          <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
            <div className="fixed inset-0 bg-black/30" /></Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 shadow-xl transition-all">
                  <Dialog.Title className="text-lg font-medium text-black mb-4">{t("addreview")}</Dialog.Title>
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="flex items-center gap-0.5">
                      {[...Array(5)].map((_, index) => {
                        const ratingValue = index + 1;
                        return <label key={index} className="cursor-pointer">
                          <input type="radio" name="rating" value={ratingValue} onClick={() => setRating(ratingValue)} onMouseEnter={() => setHover(ratingValue)} onMouseLeave={() => setHover(0)} className="hidden" />
                          <StarIcon className={`w-5 h-5 transition-colors ${ratingValue <= (hover || rating) ? 'text-yellow-500' : 'text-gray-400'}`} /></label>;
                      })}
                      <span className="ml-2 text-sm font-medium text-black">{rating}.0 {t("outof")} 5</span></div>

                    <div>
                      <label htmlFor="comment" className="block text-sm font-medium text-black mb-2">{t("review-desc")}</label>
                      <textarea id="comment" value={comment} onChange={(e) => setComment(e.target.value)} rows="6" className="w-full rounded-lg border border-gray-200 bg-gray-50 p-3 text-sm text-black placeholder-gray-400 focus:border-orange-500 focus:ring-orange-500" required /></div>

                    <div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-200">
                      <button type="button" onClick={() => setIsOpen(false)} className="px-4 py-2 text-sm font-medium text-black hover:text-orange-500 focus:outline-none">{t("cancel")}</button>
                      <button type="submit" className={`rounded-lg px-4 py-2 text-sm font-medium text-white transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 
                      ${btnLoading ? "bg-black/60 cursor-not-allowed" : "bg-black hover:bg-black/80"}`} disabled={btnLoading}>
                        {btnLoading ? (
                          <span className="flex justify-center items-center">
                            <ArrowPathIcon className="animate-spin text-white size-5 mr-2"/>
                            {t("loading")}
                          </span>
                        ) : (
                          t("submit")
                        )}
                      </button>
                    </div>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
};